import React, { FC } from 'react';

import { useMenuContext } from 'state/menu';
import { isWeb } from 'utils/environment';

import { Features } from '../features';

import { HomePageSkeleton } from './home-page-skeleton';
import { Components, IHomePageViewProps } from './types';

export const HomePageView: FC<React.PropsWithChildren<IHomePageViewProps>> = ({
  isLoading,
  featureHomePage,
}) => {
  const { activeDayParts } = useMenuContext();

  const featureHomePageComponents = featureHomePage?.components;

  const components = React.useMemo(() => {
    // Footer should be fixed on WEB for legal reasons
    const footerComponents: Components = isWeb ? [{ _id: 'Footer', __typename: 'Footer' }] : [];

    const allDaySimpleHomePage = featureHomePageComponents?.filter(
      component =>
        component && component.__typename === 'SimpleHomePage' && component.daypart === 'All'
    )[0];

    const simpleHomePage = featureHomePageComponents?.filter(
      component =>
        component &&
        component.__typename === 'SimpleHomePage' &&
        component.daypart &&
        activeDayParts.find(daypart => daypart.key === component.daypart)
    )[0];

    const components = [
      ...(featureHomePageComponents?.filter(
        component => component && component.__typename !== 'SimpleHomePage'
      ) || []),
      ...footerComponents,
    ];

    if (simpleHomePage) {
      components.unshift(simpleHomePage);
    } else if (allDaySimpleHomePage) {
      components.unshift(allDaySimpleHomePage);
    }
    return components;
  }, [activeDayParts, featureHomePageComponents]);

  if (isLoading || !components) {
    return <HomePageSkeleton />;
  }

  return <Features components={components} />;
};
